/*
 *
 * StoryPage actions
 *
 */

const SCOPE = 'app/StoryPage/';
export const ActionTypes = {
    RESET_CONTENTS: `${SCOPE}RESET_CONTENTS`,
    SET_PARAMS: `${SCOPE}SET_PARAMS`,
    SET_IS_404: `${SCOPE}SET_IS_404`,

    SET_PAGE_IS_LOADED: `${SCOPE}SET_PAGE_IS_LOADED`,
    FETCH_PAGE: `${SCOPE}FETCH_PAGE`,
    FETCH_PAGE_STARTED: `${SCOPE}FETCH_PAGE_STARTED`,
    FETCH_PAGE_SUCCESSFULLY: `${SCOPE}FETCH_PAGE_SUCCESSFULLY`,
    FETCH_PAGE_FAILED: `${SCOPE}FETCH_PAGE_FAILED`,
    FETCH_PAGE_CANCELLED: `${SCOPE}FETCH_PAGE_CANCELLED`,

    SET_ACTIVITY_IS_LOADED: `${SCOPE}SET_ACTIVITY_IS_LOADED`,
    FETCH_ACTIVITY: `${SCOPE}FETCH_ACTIVITY`,
    FETCH_ACTIVITY_STARTED: `${SCOPE}FETCH_ACTIVITY_STARTED`,
    FETCH_ACTIVITY_SUCCESSFULLY: `${SCOPE}FETCH_ACTIVITY_SUCCESSFULLY`,
    FETCH_ACTIVITY_FAILED: `${SCOPE}FETCH_ACTIVITY_FAILED`,
    FETCH_ACTIVITY_CANCELLED: `${SCOPE}FETCH_ACTIVITY_CANCELLED`,

    SET_STORIES_IS_LOADED: `${SCOPE}SET_STORIES_IS_LOADED`,
    FETCH_STORIES: `${SCOPE}FETCH_STORIES`,
    FETCH_STORIES_STARTED: `${SCOPE}FETCH_STORIES_STARTED`,
    FETCH_STORIES_SUCCESSFULLY: `${SCOPE}FETCH_STORIES_SUCCESSFULLY`,
    FETCH_STORIES_FAILED: `${SCOPE}FETCH_STORIES_FAILED`,
    FETCH_STORIES_CANCELLED: `${SCOPE}FETCH_STORIES_CANCELLED`,

    SET_RECOMMENDS_IS_LOADED: `${SCOPE}SET_RECOMMENDS_IS_LOADED`,
    FETCH_RECOMMENDS: `${SCOPE}FETCH_RECOMMENDS`,
    FETCH_RECOMMENDS_STARTED: `${SCOPE}FETCH_RECOMMENDS_STARTED`,
    FETCH_RECOMMENDS_SUCCESSFULLY: `${SCOPE}FETCH_RECOMMENDS_SUCCESSFULLY`,
    FETCH_RECOMMENDS_FAILED: `${SCOPE}FETCH_RECOMMENDS_FAILED`,
    FETCH_RECOMMENDS_CANCELLED: `${SCOPE}FETCH_RECOMMENDS_CANCELLED`,

    SET_USER_IMAGES_IS_LOADED: `${SCOPE}SET_USER_IMAGES_IS_LOADED`,
    FETCH_USER_IMAGES: `${SCOPE}FETCH_USER_IMAGES`,
    FETCH_USER_IMAGES_STARTED: `${SCOPE}FETCH_USER_IMAGES_STARTED`,
    FETCH_USER_IMAGES_SUCCESSFULLY: `${SCOPE}FETCH_USER_IMAGES_SUCCESSFULLY`,
    FETCH_USER_IMAGES_FAILED: `${SCOPE}FETCH_USER_IMAGES_FAILED`,
    FETCH_USER_IMAGES_CANCELLED: `${SCOPE}FETCH_USER_IMAGES_CANCELLED`,
};

/**
 * Common
 */
export const setIs404 = (is404) => ({
    type: ActionTypes.SET_IS_404,
    is404,
});

export const setParams = (params) => ({
    type: ActionTypes.SET_PARAMS,
    params,
});

export const resetContents = () => ({ type: ActionTypes.RESET_CONTENTS });

/**
 * Page
 */
export const setPageIsLoaded = (isLoaded) => ({ type: ActionTypes.SET_PAGE_IS_LOADED, isLoaded });
export const fetchPage = () => ({ type: ActionTypes.FETCH_PAGE });
export const fetchPageStarted = () => ({ type: ActionTypes.FETCH_PAGE_STARTED });
export const fetchPageSuccessfully = (res) => ({
    type: ActionTypes.FETCH_PAGE_SUCCESSFULLY,
    res,
});
export const fetchPageFailed = (error) => ({
    type: ActionTypes.FETCH_PAGE_FAILED,
    error,
});
export const fetchPageCancelled = () => ({
    type: ActionTypes.FETCH_PAGE_CANCELLED,
});

/**
 * Activity
 */
export const setActivityIsLoaded = (isLoaded) => ({
    type: ActionTypes.SET_ACTIVITY_IS_LOADED,
    isLoaded,
});
export const fetchActivity = () => ({ type: ActionTypes.FETCH_ACTIVITY });
export const fetchActivityStarted = () => ({ type: ActionTypes.FETCH_ACTIVITY_STARTED });
export const fetchActivitySuccessfully = (res) => ({
    type: ActionTypes.FETCH_ACTIVITY_SUCCESSFULLY,
    res,
});
export const fetchActivityFailed = (error) => ({
    type: ActionTypes.FETCH_ACTIVITY_FAILED,
    error,
});
export const fetchActivityCancelled = () => ({
    type: ActionTypes.FETCH_ACTIVITY_CANCELLED,
});

/**
 * Stories
 */
export const setStoriesIsLoaded = (isLoaded) => ({
    type: ActionTypes.SET_STORIES_IS_LOADED,
    isLoaded,
});
export const fetchStories = () => ({ type: ActionTypes.FETCH_STORIES });
export const fetchStoriesStarted = () => ({ type: ActionTypes.FETCH_STORIES_STARTED });
export const fetchStoriesSuccessfully = (res) => ({
    type: ActionTypes.FETCH_STORIES_SUCCESSFULLY,
    res,
});
export const fetchStoriesFailed = (error) => ({
    type: ActionTypes.FETCH_STORIES_FAILED,
    error,
});
export const fetchStoriesCancelled = () => ({
    type: ActionTypes.FETCH_STORIES_CANCELLED,
});

/**
 * Recommends
 */
export const setRecommendsIsLoaded = (isLoaded) => ({
    type: ActionTypes.SET_RECOMMENDS_IS_LOADED,
    isLoaded,
});
export const fetchRecommends = () => ({ type: ActionTypes.FETCH_RECOMMENDS });
export const fetchRecommendsStarted = () => ({ type: ActionTypes.FETCH_RECOMMENDS_STARTED });
export const fetchRecommendsSuccessfully = (res) => ({
    type: ActionTypes.FETCH_RECOMMENDS_SUCCESSFULLY,
    res,
});
export const fetchRecommendsFailed = (error) => ({
    type: ActionTypes.FETCH_RECOMMENDS_FAILED,
    error,
});
export const fetchRecommendsCancelled = () => ({
    type: ActionTypes.FETCH_RECOMMENDS_CANCELLED,
});

/**
 * User images
 */
export const setUserImagesIsLoaded = (isLoaded) => ({
    type: ActionTypes.SET_USER_IMAGES_IS_LOADED,
    isLoaded,
});
export const fetchUserImages = () => ({ type: ActionTypes.FETCH_USER_IMAGES });
export const fetchUserImagesStarted = () => ({ type: ActionTypes.FETCH_USER_IMAGES_STARTED });
export const fetchUserImagesSuccessfully = (res) => ({
    type: ActionTypes.FETCH_USER_IMAGES_SUCCESSFULLY,
    res,
});
export const fetchUserImagesFailed = (error) => ({
    type: ActionTypes.FETCH_USER_IMAGES_FAILED,
    error,
});
export const fetchUserImagesCancelled = () => ({
    type: ActionTypes.FETCH_USER_IMAGES_CANCELLED,
});
